import { PDFViewer, WorkerFetch } from '@/static/esignSdk/source/viewer';
import '@/static/esignSdk/source/viewer/index.css';
import FormFillPlugin from './plugins/FormFillPlugin';

export function initPdfSdk({ url, viewer, password, file }) {
  if (!viewer) {
    return Promise.reject('viewRef.current is null');
  }
  return initWorkerFetch()
  .then((workerFetch) => {
    const pdfViewer = initPDFViewer(workerFetch, viewer);
    return loadPdf({ url, password, file, pdfViewer, workerFetch });
  }).then(({ workerFetch, pdfDocRender, pdfViewer }) => {
      window.pdfDocRender = pdfDocRender;
      return Promise.resolve({workerFetch, pdfDocRender});
  })
}

export function loadPdf({
  file,
  url,
  p,
  pdfDocRender,
  pdfViewer,
  workerFetch,
}) {
  let promise;
  if (pdfDocRender) {
    promise = pdfDocRender.destroy().then(() => resetPlugin());
  } else {
    promise = Promise.resolve();
  }
  return promise.then(() => {
    let promise2;
    if (url) {
      promise2 = workerFetch.request('requestPDF', {
        url,
        p,
      });
    }
    if (file) {
      promise2 = workerFetch.request(
        'uploadPDF',
        {
          file,
          p,
        },
        { stringify: false },
      );
    }
    if (!promise2) {
      return Promise.reject('loadPdf mission params');
    }
    return promise2.then(({ docId, pageCount }) => {
      pdfDocRender = pdfViewer.render(docId, pageCount);
      return { workerFetch, pdfViewer, pdfDocRender };
    });
  });
}

function initWorkerFetch() {
  const workerFetch = new WorkerFetch(
    {
      url:  '../../static/esignSdk/dist/worker.js',
      wasm: {
        path: '../wasm/signature/', // mini_49e53178
        type: 4,
      },
      font: {
        externalPath: '../font/external/',
        cmapsPath: '../font/cmaps/',
        foxitPath: '../font/foxit/',
      },
      useCustomWorker: true,
    },
    {},
  );
  const proctedKey = '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';
  return workerFetch
    .request('license', proctedKey)
    .then(
      (v) => {
        return workerFetch;
      },
      (error) => {
        console.error('sdk fetch license err: ', error);
      },
    );
}

function initPDFViewer(workerFetch, eViewer) {
  const bound = eViewer.parentElement.getBoundingClientRect();
  const pdfViewer = new PDFViewer({
    workerFetch,
    eViewer,
    //eRoot: eViewer.parentNode,
    width: bound.width,
    height: bound.height,
  });

  pdfViewer.pluginStorage.setItem('form-fill', FormFillPlugin);
  pdfViewer.pluginStorage.pushDefaults('form-fill');

  return pdfViewer;
}

function resetPlugin() {}
